import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Ask whether a new connected mission should sit before or after a milestone
 * the source mission already feeds into.
 */
const AddMissionAroundMilestoneModal = ({
  isOpen,
  milestoneName = '',
  nodeType = 'task',
  onChoose,
  onCancel,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onCancel?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const displayName = milestoneName?.trim() || 'this milestone';
  const itemLabel = nodeType === 'decision' ? 'decision' : 'mission';

  return createPortal(
    <>
      <div className="milestone-editor-backdrop" onClick={onCancel} role="presentation" />
      <div
        className="milestone-editor milestone-editor--choice"
        role="dialog"
        aria-label={`Add ${itemLabel} around milestone`}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="milestone-editor__header">
          <span className="milestone-editor__title">
            <span className="milestone-editor__title-flag" aria-hidden="true">🚩</span>
            Add {itemLabel}
          </span>
          <button type="button" className="milestone-editor__close" onClick={onCancel} aria-label="Close">
            ×
          </button>
        </div>

        <p className="milestone-editor__choice-lede">
          This mission feeds directly into the <strong>{displayName}</strong> milestone.
          Add the new {itemLabel} before or after it?
        </p>

        <div className="milestone-editor__section">
          <div className="milestone-editor__side-toggle milestone-editor__side-toggle--stack">
            <button
              type="button"
              className="milestone-editor__side-btn"
              onClick={() => onChoose?.('before')}
            >
              <span className="milestone-editor__choice-label">Before {displayName}</span>
              <span className="milestone-editor__choice-desc">
                Insert it between this mission and the milestone
              </span>
            </button>
            <button
              type="button"
              className="milestone-editor__side-btn"
              onClick={() => onChoose?.('after')}
            >
              <span className="milestone-editor__choice-label">After {displayName}</span>
              <span className="milestone-editor__choice-desc">
                Place it downstream of the milestone
              </span>
            </button>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
};

export default AddMissionAroundMilestoneModal;
